module.exports = {
      id: "vikatantv-usage",
      viewBox: "0 0 25.176 25.204",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#vikatantv",
      toString: function () {
        return this.url;
      }
    }